import { formatDateFromString } from '@chargeafter/utils';

type FormatDisclosureDescriptionProps = {
  description: string;
  amount?: string | number;
  monthlyPayment?: number;
  numberOfPeriods?: number;
  minimumPurchaseAmount?: string | number;
  startDate?: string;
  endDate?: string;
};

const formatAmount = (value?: string | number) =>
  value && Number(value).toLocaleString();

export const formatDescriptionPlaceholders = ({
  description,
  amount,
  monthlyPayment,
  numberOfPeriods,
  minimumPurchaseAmount,
  startDate,
  endDate,
}: FormatDisclosureDescriptionProps) =>
  description.replace(
    /{TOTAL_PAYMENT_AMOUNT}|{MONTHLY_PAYMENT_AMOUNT}|{PROMO_TERM}|{FINANCE_AMOUNT}|{MINIMUM_PURCHASE_AMOUNT}|{EFFECTIVE_DATE}|{END_DATE}/g,
    (match) => {
      switch (match) {
        case '{TOTAL_PAYMENT_AMOUNT}':
        case '{FINANCE_AMOUNT}':
          return `${formatAmount(amount) || ''}`;

        case '{MONTHLY_PAYMENT_AMOUNT}':
          return `${formatAmount(monthlyPayment) || ''}`;

        case '{PROMO_TERM}':
          return `${numberOfPeriods || ''}`;

        case '{MINIMUM_PURCHASE_AMOUNT}':
          return `${formatAmount(minimumPurchaseAmount) || ''}`;

        case '{EFFECTIVE_DATE}':
          return formatDateFromString(
            startDate?.replace('Z', ''),
            'yyyy-MM-dd'
          );

        case '{END_DATE}':
          return formatDateFromString(endDate?.replace('Z', ''), 'yyyy-MM-dd');
      }
    }
  );
